import { surmountLogoLight } from "assets/icons";
import CRS_FORM from "assets/documents/CRS_QB.pdf";
import ADV_FORM from "assets/documents/ADV_QB.pdf";

import { FooterContainer } from "./Footer.styles";

// Bundled through Vite -> emitted as /assets/<name>-<hash>.pdf in the build.
const RESOURCES = [
  { label: "Form CRS", href: CRS_FORM },
  { label: "ADV Part 2", href: ADV_FORM },
];

export const Footer = () => {
  return (
    <FooterContainer>
      <div className="footer-inner">
        <img
          src={surmountLogoLight}
          alt="Surmount AI"
          className="footer-logo"
        />

        <div className="resources">
          <h3 className="resources-title">Resources</h3>
          <div className="resources-links">
            {RESOURCES.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </FooterContainer>
  );
};

export default Footer;
